import _taggedTemplateLiteral from "/codebuild/output/src1506462530/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import React from 'react';
import { getInitials } from '@guryou/utils';
import { Avatar as MuiAvatar } from '@material-ui/core';
import Badge from '@material-ui/core/Badge';
import styled from 'styled-components';
import { stringToColor } from './stringToColor';
const CustomMuiAvatar = styled(MuiAvatar)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &:hover {\n    opacity: 0.9;\n    cursor: pointer;\n  }\n"])));
const Avatar = _ref => {
  let {
    text,
    imageSrc,
    imageAlt,
    onClick,
    icon,
    size = 'small',
    border = false
  } = _ref;
  let content;
  if (imageSrc) {
    content = /*#__PURE__*/React.createElement(CustomMuiAvatar, {
      className: "".concat(size, " ").concat(border && 'border'),
      onClick: onClick,
      src: imageSrc,
      alt: imageAlt
    });
  } else {
    content = /*#__PURE__*/React.createElement(CustomMuiAvatar, {
      className: "".concat(size, " ").concat(border && 'border'),
      onClick: onClick,
      style: {
        backgroundColor: stringToColor(text)
      }
    }, getInitials(text));
  }
  if (!icon) {
    return content;
  }
  return /*#__PURE__*/React.createElement(Badge, {
    overlap: "circle",
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    badgeContent: icon
  }, content);
};
export { Avatar };